export enum ProductScoreTrendLabel {
  VERY_GOOD = 'عالی',
  GOOD = 'خوب',
  WEAK = 'ضعیف',
  VERY_WEAK = 'خیلی ضعیف'
}

export enum ProductScoreTrendType {
  atp = 'متن ۱',
  ptk = 'متن ۲',
  penetration = 'متن ۳'
}

export enum PerformanceOverviewLabel {
  biker_wait_score = 'سرعت تحویل به پیک',
  nfc_score = 'نیازمند تماس',
  negative_review_score = 'نظرات',
  customer_rating_score = 'رضایت مشتریان',
  ptk_score = 'قیمت عادلانه',
  discount_score = 'تخفیف',
  atp_score = 'موجودی',
  penetration_score = 'تنوع کالا'
}

export enum PinAvailability {
  free = '',
  reserve = 'رزرو شده',
  purchased = 'به فروش رفته'
}

export enum PinState {
  waiting = 'در انتظار اجرا',
  inprogress = 'در حال اجرا',
  done = 'پایان یافته',
  refund = 'بازپس گرفته شده'
}

export enum CouponState {
  draft = 'در انتظار اجرا',
  active = 'در حال اجرا',
  completed = 'پایان یافته'
}

export enum ProState {
  INIT = 'در انتظار اجرا',
  ACTIVE = 'در حال اجرا',
  DONE = 'پایان یافته',
  DELETED = 'حذف شده'
}

export enum ExtraDeliveryState {
  init = 'در انتظار اجرا',
  active = 'در حال اجرا',
  paused = 'متوقف شده',
  deleted = 'حذف شده'
}
export enum TicketState {
  inprogress = 'در حال اجرا',
  done = 'پایان یافته',
  created = 'در انتظار اجرا'
}

export enum NotificationFilter {
  all = 'همه',
  order = 'سفارش‌ها',
  vps = 'امتیاز عملکرد',
  promotion = 'ترقی',
  notification = 'اعلان‌ها',
  ticket = 'تیکت‌ها'
}

export enum NotificationType {
  order = 'سفارش',
  vps = 'امتیاز عملکرد',
  promotion_center = 'ترقی',
  notification = 'اعلان',
  ticket = 'تیکت'
}

export enum RegisterState {
  PENDING = 0,
  REJECTED = 1,
  APPROVED = 2,
  CANCELED = 3
}

export enum RegisterStep {
  NotRegistered = 0,
  Register = 1,
  GeneralInfo = 2,
  UploadDocuments = 3,
  VendorInfo = 4,
  BankInfo = 5,
  WaitingForAdminApprove = 6,
  UploadKycData = 7,
  SignContract = 8,
  Finish = 9
}
